// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shop-section .title .shop-book {
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
    margin-bottom: 2rem;
    color: #B54708
}

.shop-section .shopcontent {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.shop-section .buy-section {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: flex-start;
}

.shop-section .book-card {
    width: 300px;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    justify-content: space-between;
    cursor: pointer;
    @media screen and (max-width: 768px) {
        width: 250px;
        
    }
}

.shop-section .book-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.shop-section .img-section {
    width: 100% !important;
    display: flex;
    justify-content: center;
    align-items: center;
}

.shop-section .book-image {
    width: 100%;
    height: auto;
    /* flex: 0; */
    object-fit: contain;
}

.shop-section .content-section {
    padding: 1rem;
    width: 100%;
    padding-bottom: 0 !important;
    flex: none
}

.shop-section .content-section .title {
    font-size: 1.2rem;
    font-weight: 600;
    cursor: pointer;
    margin-bottom: 0.5rem;
}

.shop-section .content-section .subtitle {
    font-size: 1rem;
    color: #555;
    margin-bottom: 0.5rem;
}

.shop-section .content-section .desc {
    font-size: 0.9rem;
    color: #777;
    margin-bottom: 1rem;
}

.shop-section .content-section .price {
    font-size: 1.2rem;
    font-weight: 600;
    color: #F09300;
    margin-bottom: 1rem;
}

.shop-section .content-section .buyButton {
    width: 100%;
    background: linear-gradient(90deg, #F09300 0%, #FFB800 100%);
    color: black;
    text-transform: none;
    font-weight: bold;
    border-radius: 40px;
    padding: 0.5rem 0;
    z-index: 10;
}

.shop-section .content-section .cart-icon {
    width: 1rem;
    margin-right: 0.5rem;
}

.shop-section .pagination {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
}

@media (max-width: 768px) {
    .shop-section .buy-section {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        justify-content: flex-start;
    }}`, "",{"version":3,"sources":["webpack://./src/pages/ebooks/buyBook.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,qDAAqD;IACrD,8BAA8B;IAC9B,eAAe;IACf;QACI,YAAY;;IAEhB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,4BAA4B;IAC5B;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,4DAA4D;IAC5D,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI;QACI,aAAa;QACb,eAAe;QACf,SAAS;QACT,2BAA2B;IAC/B,CAAC","sourcesContent":[".shop-section .title .shop-book {\n    font-size: 1.5rem;\n    font-weight: bold;\n    text-align: center;\n    margin-bottom: 2rem;\n    color: #B54708\n}\n\n.shop-section .shopcontent {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.shop-section .buy-section {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    justify-content: flex-start;\n}\n\n.shop-section .book-card {\n    width: 300px;\n    border-radius: 10px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    justify-content: space-between;\n    cursor: pointer;\n    @media screen and (max-width: 768px) {\n        width: 250px;\n        \n    }\n}\n\n.shop-section .book-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.shop-section .img-section {\n    width: 100% !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.shop-section .book-image {\n    width: 100%;\n    height: auto;\n    /* flex: 0; */\n    object-fit: contain;\n}\n\n.shop-section .content-section {\n    padding: 1rem;\n    width: 100%;\n    padding-bottom: 0 !important;\n    flex: none\n}\n\n.shop-section .content-section .title {\n    font-size: 1.2rem;\n    font-weight: 600;\n    cursor: pointer;\n    margin-bottom: 0.5rem;\n}\n\n.shop-section .content-section .subtitle {\n    font-size: 1rem;\n    color: #555;\n    margin-bottom: 0.5rem;\n}\n\n.shop-section .content-section .desc {\n    font-size: 0.9rem;\n    color: #777;\n    margin-bottom: 1rem;\n}\n\n.shop-section .content-section .price {\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: #F09300;\n    margin-bottom: 1rem;\n}\n\n.shop-section .content-section .buyButton {\n    width: 100%;\n    background: linear-gradient(90deg, #F09300 0%, #FFB800 100%);\n    color: black;\n    text-transform: none;\n    font-weight: bold;\n    border-radius: 40px;\n    padding: 0.5rem 0;\n    z-index: 10;\n}\n\n.shop-section .content-section .cart-icon {\n    width: 1rem;\n    margin-right: 0.5rem;\n}\n\n.shop-section .pagination {\n    margin-top: 2rem;\n    display: flex;\n    justify-content: center;\n}\n\n@media (max-width: 768px) {\n    .shop-section .buy-section {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 16px;\n        justify-content: flex-start;\n    }}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
